import { Routes } from '@angular/router';

export const reportsRoutes: Routes = [
  {
    path: 'check-in',
    loadComponent: () => import('./pages/check-in/check-in.component').then(m => m.CheckInComponent),
  },
  {
    path: 'missions',
    loadComponent: () => import('./pages/missions/missions.component').then(m => m.MissionsComponent),
  },
  {
    path: 'missions/:id',
    loadComponent: () => import('./pages/missions/mission-detail/mission-detail.component').then(m => m.MissionDetailComponent),
  },
  {
    path: 'communiques',
    loadComponent: () => import('./pages/communiques/communiques.component').then(m => m.CommuniquesComponent),
  },
  {
    path: 'digital-stamps',
    loadComponent: () => import('./pages/digital-stamps/digital-stamps.component').then(m => m.DigitalStampsComponent),
  },
  {
    path: 'bills-payments',
    loadComponent: () => import('./pages/bills-payments/bills-payments.component').then(m => m.BillsPaymentsComponent),
  },
  {
    path: 'retentions',
    loadComponent: () => import('./pages/retentions/retentions.component').then(m => m.RetentionsComponent),
  },
  {
    path: 'trader-info',
    loadComponent: () => import('./pages/traders/traders.component').then(m => m.TradersComponent),
  },
  {
    path: 'sales-advance',
    loadComponent: () => import('./pages/sales-advance/sales-advance.component').then(m => m.SalesAdvanceComponent),
  },
  {
    path: 'actions',
    loadComponent: () => import('./pages/actions/actions.component').then(m => m.ActionsComponent),
  },
  {
    path: 'course',
    loadComponent: () => import('./pages/course/course.component').then(m => m.CourseComponent),
  },
  {
    path: 'notification',
    loadComponent: () => import('./pages/notification/notification.component').then(m => m.NotificationComponent),
  },
  {
    path: 'qrs',
    loadComponent: () => import('./pages/dynamic-qr/dynamic-qr.component').then(m => m.DynamicQrComponent),
  },
  {
    path: 'compartidos-qr',
    loadComponent: () => import('./pages/compartidos-qr/compartidos-qr.component').then(m => m.CompartidosQrComponent),
  },
  {
    path: '**',
    redirectTo: 'check-in',
  },
];
